import { Row, Col, Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { IcoCommonProp } from "../../../../Type/CommonComponant";

const IcoCommon = ({ title, iconType, parentCallback }: IcoCommonProp) => {
  const getItag = (tag: string) => parentCallback(tag);

  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={title} />
        <CardBody>
          <Row className="icon-lists">
            {iconType.map((iconItem: string, i: number) => (
              <Col sm="6" lg="4" key={i} onClick={() => { getItag(iconItem);}}>
                <i className={`icofont icofont-${iconItem}`}></i> {iconItem}
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default IcoCommon;
